import logger from '../../util/logger';
import { FinancialAccountUser } from './interfaces';
import { orgsRequest } from './request';

const GET_FINANCIAL_ACCT_USERS_QUERY = `
  query FinancialAcctUsers($finAcctId: ID!) {
    financialAcctUsers(finAcctId: $finAcctId) {
      processor
      kycId
      personId
      userId
      isRepresentative
      finAcctId
      userId
      acctId
    }
  }
`;

const GET_FINANCIAL_ACCT_USERS_BY_KYC_QUERY = `
  query FinancialAcctUsersByKyc($kycId: ID!) {
    financialAcctUsersByKyc(kycId: $kycId) {
      acctId
      personId
      processor
      kycId
      isRepresentative
      finAcctId
      userId
      acctId
    }
  }
`;

const GET_FINANCIAL_ACCT_USERS_BY_USER_ID_QUERY = `
query FinancialAcctUsersByUserId($userId: ID!) {
    userFinancialAccounts(userId: $userId) {
      personId
      processor
      kycId
      isRepresentative
      finAcctId
      userId
      acctId
    }
  }
`;

const DELETE_FINANCIAL_ACCT_USER_MUTATION = `
mutation FinAcctUserAssociationDelete($finAcctId: ID!, $userId: ID!) {
  finAcctUserAssociationDelete(finAcctId: $finAcctId, userId: $userId) {
    errors {
      message
      type
    }
    success
  }
}`;

export const getFinancialAcctUsers = async (
  finAcctId: string,
): Promise<FinancialAccountUser[]> => {
  const financialAcctUsersRes = await orgsRequest(
    GET_FINANCIAL_ACCT_USERS_QUERY,
    {
      finAcctId,
    },
  );
  const financialAcctUsersJson = await financialAcctUsersRes.json();
  return (financialAcctUsersJson.data.financialAcctUsers || []).filter(
    (fau: FinancialAccountUser) =>
      fau.processor !== undefined &&
      fau.processor !== null &&
      fau.kycId !== undefined &&
      fau.kycId !== null &&
      fau.personId !== undefined &&
      fau.personId !== undefined &&
      fau.userId !== undefined &&
      fau.userId !== null,
  );
};

export const getFinancialAcctUsersByKycId = async (
  kycId: string,
): Promise<FinancialAccountUser[]> => {
  const financialAcctUsersRes = await orgsRequest(
    GET_FINANCIAL_ACCT_USERS_BY_KYC_QUERY,
    {
      kycId,
    },
  );
  const financialAcctUsersJson = await financialAcctUsersRes.json();
  return financialAcctUsersJson.data.financialAcctUsersByKyc;
};

export const getFinancialAcctUsersByUserId = async (
  userId: string,
): Promise<FinancialAccountUser[]> => {
  const financialAcctUsersRes = await orgsRequest(
    GET_FINANCIAL_ACCT_USERS_BY_USER_ID_QUERY,
    {
      userId,
    },
  );
  const financialAcctUsersJson = await financialAcctUsersRes.json();
  return financialAcctUsersJson.data.userFinancialAccounts;
};

export const deleteFinancialAcctUser = async (
  finAcctId: string,
  userId: string,
): Promise<void> => {
  const deleteFinancialAcctUserRes = await orgsRequest(
    DELETE_FINANCIAL_ACCT_USER_MUTATION,
    {
      finAcctId,
      userId,
    },
  );
  const resJson = await deleteFinancialAcctUserRes.json();
  if (!resJson.data.finAcctUserAssociationDelete.success) {
    throw new Error(
      `Could not delete financial acct user association between ${finAcctId} and ${userId}. ${
        resJson.data.finAcctUserAssociationDelete.errors || []
      }`,
    );
  }
};

export const getAccountRepresentative = async (
  finAcctId: string,
): Promise<FinancialAccountUser> => {
  const financialAcctUsers = await getFinancialAcctUsers(finAcctId);
  logger(
    'getAccountRepresentative financialAcctUsers',
    false,
    financialAcctUsers,
  );
  const representative = financialAcctUsers.find((fau) => fau.isRepresentative);
  logger('getAccountRepresentative representative', false, representative);
  if (representative === undefined) {
    throw new Error(`Could not find existing representative for ${finAcctId}`);
  }
  return representative;
};
